export const MULTICALL_L1_ADDRESS = '0x1F98415757620B543A52E61c46B32eB19261F984'
export const QUOTER_L1_ADDRESS = "0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6";
export const FACTORY_ADDRESS = "0x1F98431c8aD98523631AE4a59f267346ea31F984";
export const WETHAddress = '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'
export const UNIAddress = '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984'
export const AddressZero = "0x0000000000000000000000000000000000000000";